export type GhlOAuthCallbackStatus = 'success' | 'error';

export const GHL_OAUTH_STATUS_STORAGE_KEY = 'ghlOAuthCallbackStatus';

const OAUTH_PARAMS = ['code', 'state', 'error', 'error_description', 'error_uri'];

export function hasOAuthParams(params: URLSearchParams): boolean {
  return OAUTH_PARAMS.some((name) => params.has(name));
}

/**
 * Succès seulement si GoHighLevel renvoie un code sans erreur. Sans paramètre OAuth (actualisation
 * après nettoyage de l'URL), on reprend le résultat déjà obtenu dans l'onglet.
 */
export function readGhlCallbackStatus(
  params: URLSearchParams,
  previousStatus: string | null,
): GhlOAuthCallbackStatus {
  if (params.has('error')) return 'error';
  if (params.get('code')?.trim()) return 'success';
  if (!hasOAuthParams(params) && previousStatus === 'success') return 'success';
  return 'error';
}

export function withoutOAuthParams(params: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(params);
  OAUTH_PARAMS.forEach((name) => next.delete(name));
  return next;
}
